import { createSlice } from "@reduxjs/toolkit";
import { toGetBranches } from "../actions/branches.actions";

const initialState = {
  branchesHome: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const branchesSlice = createSlice({
  name: "branches",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetBranches.pending, (state) => {
      state.branchesHome = { list: [], status: "idle" };
    });
    builder.addCase(toGetBranches.fulfilled, (state, action) => {
      state.branchesHome = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetBranches.rejected, (state, action) => {
      state.branchesHome = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default branchesSlice.reducer;
